import {
  TRANSTYPE_VALUE,
  VALUE_TAB_CONSTRUCTION_MATERIALS_PRODUCT,
} from "app/common/LocalConst";
import { getAvailabilityQuantityByUsedUnit } from "app/common/inventoryUtils";
import { getCurrentStaff } from "app/common/LocalFunction";
import { SearchServiceTreatment } from "app/common/Model/SearchObject";
import { PageResponse } from "app/common/Model/Shared";
import { initStoreRequestFromSvitem } from "app/services/ServiceRequestItem";
import { sriTreatmentReport } from "app/services/ServiceRequestItemService";
import {
  fetchStockAvailabilityForProducts,
  stockOutListFromHis,
} from "app/services/StoreRequestService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
import { TAB_LIST_CONSTRUCTION } from "./ConstructionMaterialsSynthesisIndex";

export default class ConstructionMaterialsSynthesisStore {
  searchObject = {
    ...new SearchServiceTreatment(),
    itemStatus: null, // Trạng thái yêu cầu,
    pageIndex: 1,
    pageSize: 10,

    orderDateFrom: new Date(new Date().setHours(0, 0, 0, 0)), // Thời gian chỉ định từ
    orderDateTo: (() => new Date(new Date().setHours(23, 59, 59, 999)))(), // Thời gian chỉ định đến
    getStaffRevenues: true,
    assigner: null,
    performDateFrom: null, // Thời gian thực hiện từ
    performDateTo: null, // Thời gian thực hiện đến
    roomId: null, // Phòng thực hiện
    healthCareSvId: null, //id cua dich vu
    performerId: null, // người thực hiện
    orderByDateFrom: true,
    currentTelesaleIds: [],
    patientSourceIds: [],
    currentPatientSourceIds: [],
  };
  currentTab = VALUE_TAB_CONSTRUCTION_MATERIALS_PRODUCT;
  pageConstructionMaterials = new PageResponse();
  initRequestStoreConstructionMaterial = null;
  listSelected = [];
  setListSelected = (list) => {
    this.listSelected = list;
  };
  openRequestStoreConstructionMaterialPopup = false;
  setCurrentTab = (tab) => {
    this.currentTab = tab;
  };
  resetSlected = false;

  constructor() {
    makeAutoObservable(this);
  }

  handleChangeFormSearch = (values) => {
    this.searchObject = {
      ...this.searchObject,
      ...values,
      getMedicationFull: true,
    };

    this.pagingSriTreatmentReport();
  };

  pagingSriTreatmentReport = async () => {
    // Không call API nếu không có cơ sở (bắt buộc)
    if (
      !this.searchObject.listDepId ||
      this.searchObject.listDepId.length === 0
    ) {
      this.pageConstructionMaterials = new PageResponse();
      this.listSelected = [];
      return;
    }

    const searchObj = this.normalizeSearchReportTreament(this.searchObject);
    this.resetSlected = !this.resetSlected;

    try {
      const { data } = await sriTreatmentReport(searchObj);

      this.pageConstructionMaterials = data;
      this.resetSlected = !this.resetSlected;
      this.listSelected = [];
    } catch (error) {
      console.error(error);
      toast.error(error);
    }
  };
  normalizeSearchReportTreament = (rawSearch = {}) => {
    const {
      //department,
      listDepId,
      room,
      performer,
      assigner,
      healthCareSv,
      serviceGroup,
      treatmentPlanCard,
      patient,
      patientSourceIds,
      currentPatientSourceIds,
      ...rest
    } = rawSearch;

    return {
      ...rest,
      //departmentId: department?.id || rawSearch?.department || null,
      listDepId: listDepId?.map((el) => el?.id) || null,
      patientSourceIds: patientSourceIds?.map((el) => el?.id) || null,
      currentPatientSourceIds:
        currentPatientSourceIds?.map((el) => el?.id) || null,
      roomId: room?.id || rawSearch?.roomId || null,
      performerId: performer?.id || rawSearch?.performerId || null,
      assignerId: assigner?.id || rawSearch?.assignerId || null,
      healthCareSvId: healthCareSv?.id || rawSearch?.healthCareSvId || null,
    };
  };

  handleOpenRequestStoreConstructionMaterialPopup = async ({ department }) => {
    await this.handleInitListStoreRequest(department, department?.storeConfig);
    this.openRequestStoreConstructionMaterialPopup = true;
  };
  handleInitListStoreRequest = async (department, storeConfig) => {
    let initData = {
      productType: TAB_LIST_CONSTRUCTION.find(
        (el) => el.value == this.currentTab
      ).type,
      svItems: this.listSelected,
    };

    try {
      let { data } = await initStoreRequestFromSvitem(initData);

      const staffSend = getCurrentStaff();

      let formatData = data?.map((el) => {
        const items = el?.items?.map((el) => ({
          ...el,
          exportedCurrentQuantity: el?.actualQuantity,
          actualQuantity: el?.actualQuantity,
        }));
        return {
          ...el,
          department: el?.department || department,
          store: el?.store || department?.storeConfig,
          dateIssue: new Date(),
          staffSend,
          items,
        };
      });

      this.initRequestStoreConstructionMaterial = {
        datas: formatData,
      };
    } catch (error) {
      toast.error(error);
    }
  };

  handleInitSingleStoreRequest = async (department, storeConfig, index) => {
    let itemSelect = this.initRequestStoreConstructionMaterial?.datas?.[index];
    const productCodes =
      [...itemSelect?.items]?.map((item) => item?.productCode) || [];

    try {
      const data = await fetchStockAvailabilityForProducts(
        storeConfig?.code,
        productCodes
      );
      let newStoreRequest;
      let items = itemSelect?.items?.map((item) => {
        const productMaping = data?.find(
          (el) => el?.productCode === item?.productCode
        );
        return {
          ...item,
          inventoryQuantity: getAvailabilityQuantityByUsedUnit(
            productMaping,
            item?.usedUnit
          ),
        };
      });
      newStoreRequest = {
        ...itemSelect,
        items,
        department,
        store: storeConfig,
      };
      const newInit = this.initRequestStoreConstructionMaterial?.datas?.map(
        (el, ind) => {
          if (ind === index) return newStoreRequest;
          return el;
        }
      );
      this.initRequestStoreConstructionMaterial = { datas: newInit };
    } catch (error) {
      toast.error(error);
    }
  };

  handleConstructionMaterialFromHis = async (values) => {
    this.resetSlected = !this.resetSlected;
    const { datas } = values;

    let formatValues = datas?.map((el) => {
      return {
        ...el,
        store: el?.store,
        storeCode: el?.store?.code,
        kind: TRANSTYPE_VALUE.EXPORT_USED,
      };
    });

    try {
      let { data } = await stockOutListFromHis(formatValues);
      if (data) {
        this.openRequestStoreConstructionMaterialPopup = false;
        this.pagingSriTreatmentReport();
        toast.success("Xuất kho thành công");
      } else {
        toast.error("Xuất kho lỗi");
      }
      this.resetSlected = !this.resetSlected;
      this.listSelected = [];
    } catch (error) {
      toast.error("Xuất kho lỗi");
      console.log("Lỗi xuất kho", error);
    }
  };

  handleCloseRequestStoreConstructionMaterialPopup = () => {
    this.openRequestStoreConstructionMaterialPopup = false;
    this.initRequestStoreConstructionMaterial = null;
  };
}
